import React from "react";
import {safeHTML} from "../../utils/safeHTML";
import Tag from "./../baseComponents/gui/tag/Tag";
import NewsAuthorBlock from "./NewsAuthorBlock";
import Button from "../baseComponents/gui/button/Button";
import {sharingList} from "../../constants/copyright";
import dynamic from "next/dynamic";
import styles from "./News.module.scss";
import classNames from "classnames";

const Share = dynamic(
  () => import('../baseComponents/helpers/share/Share'),
  {ssr: false}
);

// TODO попробовать разобраться с Share

const NewsHeader = React.forwardRef(
  function NewsHeader({title, author, tags}, ref) {
    return (
      <div className={styles.news__header} ref={ref}>
        <h1 className={styles.news__title}>{safeHTML(title)}</h1>
        {author && <NewsAuthorBlock {...author}/>}
        <div className={styles.news__tags}>
          {tags?.map((el, id) => {
            return el && <Tag key={`tag-${id}`} {...el}/>
          })}
        </div>
        <div className={styles.news__sharing}>
          {sharingList?.map(({link, type, text}, index) => {
              return (<Share type={type} text={title}>
                <Button icon={`share/${type}`} key={`item-${index}`}
                        tag={"a"}
                        area-label={`поделиться в соцсети ${type}`}
                        title={`поделиться в соцсети ${type}`}
                        className={classNames(styles.news__sharingItem, styles[`news__sharingItem_${type}`])}
                />
              </Share>)
            }
          )}
        </div>
      </div>
    );
  });
export default NewsHeader;
NewsHeader.propTypes = {};

